import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, input, ViewEncapsulation } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Pair } from '../../models/main/pair'
import { DdcCardCategoryComponent } from '../ddc-card-category/ddc-card-category.component'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'
import { DdcDicSComponent } from '../ddc-dic-s/ddc-dic-s.component'
import { DdcPrivacyComponent } from '../ddc-privacy/ddc-privacy.component'
import { DdcProfilePicComponent } from '../ddc-profile-pic/ddc-profile-pic.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-read-pair-mobile-sheet',
  templateUrl: './ddc-read-pair-mobile-sheet.component.html',
  styleUrl: './ddc-read-pair-mobile-sheet.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    DdcDicSComponent,
    DdcPrivacyComponent,
    DdcTextGradientComponent,
    DdcCountryFlagComponent,
    DdcCardCategoryComponent,
    DdcProfilePicComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcReadPairMobileSheetComponent {
  pair = input<Pair>(undefined)
  _isDarkTheme = false
  _isLightTheme = true
  _isPaperTheme = false
  constructor(
    private readDialogRef: MatDialogRef<DdcReadPairMobileSheetComponent>,
    private _themeService: ThemeService,
  ) {
    this._themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === 'dark-theme'
      this._isLightTheme = theme === 'light-theme'
      this._isPaperTheme = theme === 'paper-theme'
    })
  }

  protected onProfilePicClick(): void {
    this.readDialogRef.close()
  }
}
